import React, { createContext, useContext } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';

const GoogleMapsContext = createContext();

// Load Places library for nearby POI searches (kept minimal to avoid perf warnings)
const GOOGLE_MAPS_LIBRARIES = ["places"]; 

export const useGoogleMaps = () => {
  const context = useContext(GoogleMapsContext);
  if (!context) {
    throw new Error('useGoogleMaps must be used within a GoogleMapsProvider');
  }
  return context;
};

export const GoogleMapsProvider = ({ children }) => {
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
    // Prevent multiple script loads
    preventGoogleFontsLoading: true,
    // No additional libraries needed for basic markers
    libraries: GOOGLE_MAPS_LIBRARIES,
  });

  const value = {
    isLoaded,
    loadError
  };

  return (
    <GoogleMapsContext.Provider value={value}>
      {children}
    </GoogleMapsContext.Provider>
  );
};
